import { Compass, SlidersHorizontal, Sprout, HandHeart } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const PILLARS = [
  { icon: Compass, title: "Understand", text: "Your child's individual patterns" },
  { icon: SlidersHorizontal, title: "Personalize", text: "Care around your child's needs" },
  { icon: Sprout, title: "Support", text: "Healthy routines and natural development" },
  { icon: HandHeart, title: "Empower", text: "Parents with practical guidance" },
];

export default function ParentSection({ onRequest }) {
  return (
    <section data-testid="parent-section" className="bg-[#FAF7F2] py-16 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-3xl">
          <Eyebrow>Chapter 01 · For Parents</Eyebrow>
          <h2 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1B3B2B] tracking-tight leading-tight">
            Your Child Doesn't Need a <em className="italic text-[#B85D43]">One-Size-Fits-All</em> Approach.
          </h2>
          <p className="mt-6 text-base text-[#2D3A32] leading-relaxed">
            Every child is different. Their patterns, needs, routines, challenges and responses can be different too.
          </p>
          <p className="mt-3 text-base text-[#5C6E62] leading-relaxed">
            The goal of a personalized consultation is to understand your child's individual pattern and provide parents
            with practical, child-specific guidance they can understand and use.
          </p>
        </Reveal>

        <div className="mt-12 lg:mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {PILLARS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.1}>
              <div
                data-testid={`pillar-${p.title.toLowerCase()}`}
                className="group h-full bg-[#F4EFE6] rounded-2xl p-7 border border-[#E5D3AD]/40 hover:border-[#C5A059] hover:-translate-y-1.5 transition-all duration-500 shadow-[0_8px_30px_rgb(27,59,43,0.05)]"
              >
                <div className="w-12 h-12 rounded-full bg-[#EAF0EC] border border-[#5B7566]/15 flex items-center justify-center group-hover:bg-[#1B3B2B] transition-colors duration-500">
                  <p.icon className="w-5 h-5 text-[#1B3B2B] group-hover:text-[#C5A059] transition-colors duration-500" />
                </div>
                <p className="mt-5 font-serif text-2xl text-[#1B3B2B]">{p.title}</p>
                <p className="mt-2 text-sm text-[#5C6E62] leading-relaxed">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15} className="mt-12 text-center">
          <button
            data-testid="parent-section-cta"
            onClick={() => onRequest()}
            className="border border-[#1B3B2B]/30 text-[#1B3B2B] font-semibold tracking-wide text-sm px-8 py-4 rounded-full hover:bg-[#1B3B2B] hover:text-[#FAF7F2] transition-all duration-300"
          >
            EXPLORE YOUR CONSULTATION PATHWAYS
          </button>
        </Reveal>
      </div>
    </section>
  );
}
